<template>
    <div>
       <div class="imgpost" ><el-image style="width: 100%;" :src="require('../../public/static/pageThree/top1.png')"  fit="fit"></el-image></div>
      
       <div class="top2Main">
<div @mouseenter="mouseImg(1)" :class="[img1Show ? 'padBorder' : '']" style="width: 120px;">
    <div class="top2img" >
        <el-image v-show="img1Show" style="width:64px;" :src="require('../../public/static/pageThree/top2_1active.png')"  fit="fit"></el-image>
        <el-image v-show="!img1Show" style="width:64px;" :src="require('../../public/static/pageThree/top2_1.png')"  fit="fit" ></el-image>

    </div>
    <div :style="{color:img1Show ? 'red' : ''}">战略定位</div>
    <el-image v-show="img1Show" style="width:32px;    position: absolute;bottom: -6px;left: 35%;" :src="require('../../public/static/pageThree/iconSan.png')"  fit="fit" ></el-image>

</div>

<div @mouseenter="mouseImg(2)"  :class="[!img2Show ? 'padBorder' : '']" style="width: 120px;">
    <div class="top3img" >
        <el-image  v-show="img2Show" style="width:64px;" :src="require('../../public/static/pageThree/top2_2.png')"  fit="fit"></el-image>
        <el-image  v-show="!img2Show" style="width:64px;" :src="require('../../public/static/pageThree/top2_2active.png')"  fit="fit"></el-image>

    </div>
    <div :style="{color:!img2Show ? 'red' : ''}">责任基石</div>
    <el-image v-show="!img2Show" style="width:32px;    position: absolute;bottom: -6px;left: 35%;" :src="require('../../public/static/pageThree/iconSan.png')"  fit="fit" ></el-image>

</div>
<div @mouseenter="mouseImg(3)"  :class="[!img3Show ? 'padBorder' : '']" style="width: 120px;">
    <div class="top4img" >
        <el-image  v-show="img3Show" style="width:64px;" :src="require('../../public/static/pageThree/top2_3.png')"  fit="fit"></el-image>
        <el-image  v-show="!img3Show" style="width:64px;" :src="require('../../public/static/pageThree/top2_3active.png')"  fit="fit"></el-image>

    </div>
    <div :style="{color:!img3Show ? 'red' : ''}">价值创造</div>
    <el-image v-show="!img3Show" style="width:32px;    position: absolute;bottom: -6px;left: 35%;" :src="require('../../public/static/pageThree/iconSan.png')"  fit="fit" ></el-image>

</div>

       </div>

<div style="width: 50%;margin: 20px auto;">
       <div  v-show="img1Show">
        <div style="font-size: 22px;color: #374352;">责任驱动的科技向善</div>
        <div style="font-size: 14px;color: #374352;margin-top: 30px;line-height: 30px;">番茄站智能科技将社会责任深度融入企业DNA，构建「技术创新×社会价值」双螺旋发展模型。我们以人工智能与云计算为核心引擎，
            在推动产业智能化变革的同时，始终将技术伦理、环境可持续、人才共成长作为战略决策的基石坐标，致力于成为科技向善的行业范式定义者。</div>
       </div>
       <div  v-show="!img2Show">
        <div style="font-size: 22px;color: #374352;">构建可持续价值三角</div>
        <div style="font-size: 14px;color: #374352;margin-top: 30px;display: flex;justify-content: space-between;">
<div style="width:30%;">
      <div><el-image   style="width:200px;" :src="require('../../public/static/pageThree/top5_1.png')"  fit="fit"></el-image> </div>
    <div style="line-height: 30px;">在算法革命浪潮中坚守人本底线，系统性构建负责任的创新体系，确保技术演进始终服务于人类共同福祉。</div>
</div>
<div style="width: 30%;">
      <div><el-image   style="width:200px;" :src="require('../../public/static/pageThree/top5_2.png')"  fit="fit"></el-image> </div>
    <div  style="line-height: 30px;">将生态意识融入技术生命全周期，积极探索数字化与低碳化的融合路径，助力建设人与自然和谐共生的未来图景。</div>
</div>
<div style="width: 30%;">
      <div><el-image   style="width:200px;" :src="require('../../public/static/pageThree/top5_3.png')"  fit="fit"></el-image> </div>
    <div  style="line-height: 30px;">打破组织边界构筑能力成长共同体，通过知识共享与机会开放，激发跨代际、跨领域的创新潜能。</div>
</div>

        </div>
       </div>
       <div v-show="!img3Show">
        <div style="font-size: 22px;color: #374352;">责任驱动的进化引擎</div>
        <div style="font-size: 14px;color: #374352;margin-top: 30px;text-align: center;line-height: 30px;">我们视社会责任为永续创新的源动力：<br> 催化产业生态正向循环：以开放技术架构促进产业链协同进化，赋能合作伙伴实现包容性增长；
            <br> 塑造可持续发展新范式：通过数字技术解耦环境约束，重塑资源效率与生态平衡的现代方程式；  <br>
            培育未来文明基因库：构建技术普惠与人文关怀交织的培育机制，奠基数字文明时代的精神底座。</div>
       </div>
    </div>

    <div style="background: #F4F8FB;padding: 60px 0;">
<div class="imgDiv">
      <div style="flex: 1;"><el-image   style="width:100%;" :src="require('../../public/static/pageThree/top6_1.png')"  fit="fit"></el-image> </div>
      <div style="margin-left: 40px;flex: 1;">
        <div class="top6_item1">以体育为翼，托举青春梦想</div>
        <div class="top6_item2">青少年是未来的缔造者。我们聚焦体育精神与学术智慧的融合，携手香港科技大学，成为其足球队战略合作伙伴。我们以尖端科技面料定制专业战袍，以人体工学设计赋能赛场表现，更以“拼搏无界”的价值观激励青年突破极限
            。这一合作不仅是对体育教育的深度支持，更是一场关于勇气、团队与超越的生命教育，让运动精神成为青年成长的底色。</div>
      </div>
</div>
<div class="imgDiv">
    <div style="margin-right: 40px;flex: 1">
        <div class="top6_item1">以绿色为笔，绘就生态长卷</div>
        <div class="top6_item2">面对气候变化，我们以行动回应时代命题。我们连续多年深度参与“阿拉善生态修复计划”，组织志愿者团队深入荒漠腹地，种植梭梭树、构建生态屏障；同时，通过技术赋能与资金支持，推动区域生态监测与可持续发展模式创新，让荒漠变绿洲的奇迹照进现实。这不仅是我们对“双碳”目标的坚定承诺，更是对人类命运共同体的深刻践行。</div>
      </div>
      <div style="flex: 1;"><el-image   style="width:100%;" :src="require('../../public/static/pageThree/top6_2.png')"  fit="fit"></el-image> </div>
     
</div>
<div class="imgDiv">
      <div style="flex: 1;"><el-image   style="width:100%;" :src="require('../../public/static/pageThree/top6_3.png')"  fit="fit"></el-image> </div>
      <div style="margin-left: 40px;flex: 1;">
        <div class="top6_item1">以责任为帆，驶向永续未来</div>
        <div class="top6_item2">展望前路，我们将继续以“商业向善”为灯塔，在创新驱动发展的航程中破浪前行，深化教育公平、绿色转型等领域的战略布局。我们相信，企业的终极价值不仅在于创造经济繁荣，更在于成为社会进步的推动者、地球生态的守护者。</div>
      </div>
</div>
    </div>
    </div>
</template>
<script>
export default {
  name: 'PageOne',// 使用多词名称

  data() {
    return {
      img1Show:true,
      img2Show:true,
      img3Show:true,



    };
  },
  methods: {
    mouseImg(val) {
      console.log(val, "9999999");
      if(val==1){
        this.img1Show=true
        this.img2Show=true
        this.img3Show=true

      }
      if(val==2){
        this.img1Show=false
        this.img2Show=false
        this.img3Show=true


      }
      if(val==3){
        this.img1Show=false
        this.img2Show=true
        this.img3Show=false

      }


    }
  }
};
</script>
<style scoped>
.top6_item1{
    padding-left: 15px;
    font-size: 28px;
color: #374352;
    text-align: left;
    border-left: 4px solid #FF2C27; ;
}
.top6_item2{
    margin-top: 30px;
    text-align: left;
    font-size: 16px;
    line-height: 30px;
    color: #374352;
}
.imgDiv{
    display: flex;
    width: 80%;
    margin: 50px auto;
}
.padBorder{
    position: relative;
    width: 120px;
    padding-bottom: 50px;
    border-bottom:4px solid #FF2C27; ;

}
.top2Main{
    display: flex;
    justify-content: space-around;
    width: 60%;
    margin:50px auto;
    border-bottom: 2px solid #E1E6EA; ;
}
/* .top2img{
    width: 64px;
    height: 64px;

    background-image: url('../../public/static/pageThree/top2_1active.png');
    background-size: cover; 
    background-repeat: no-repeat;
}
.top2img:hover{
    width: 64px;
    height: 64px;

    background-image: url('../../public/static/pageThree/top2_1active.png');
    background-size: cover; 
    background-repeat: no-repeat;
}
.top3img{
    background-image: url('../../public/static/pageThree/top2_2.png');
    background-size: cover; 
    width: 64px;
    height: 64px;
}
.top3img:hover{
    background-image: url('../../public/static/pageThree/top2_2active.png');
}
.top4img{
    background-image: url('../../public/static/pageThree/top2_3.png');
    background-size: cover;
    background-repeat: no-repeat;
    width: 64px;
    height: 64px;
} */
</style>